// frontend/src/pages/PaymentSuccess.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import './PaymentSuccess.css';

function PaymentSuccess() {
  const { t } = useTranslation();
  // const navigate = useNavigate(); // Använder window.location istället
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Ge webhook tid att uppdatera databasen (2 sekunder)
    const timer = setTimeout(() => {
      setLoading(false);
      
      // Om användaren är inloggad, uppdatera localStorage
      const token = localStorage.getItem('token');
      if (token) {
        // Uppdatera accountType i localStorage
        localStorage.setItem('accountType', 'premium');
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleContinue = () => {
    // Ladda om sidan för att uppdatera userPlan från backend
    window.location.href = '/dashboard';
  };

  return (
    <div>
      <Navbar />
      <div className="payment-success-page">
        <div className="success-container">
          {loading ? (
            <div className="loading-animation">
              <div className="spinner"></div>
              <h2>{t('payment.processing', 'Bearbetar din betalning...')}</h2>
              <p>{t('payment.pleaseWait', 'Vänligen vänta ett ögonblick')}</p>
            </div>
          ) : (
            <>
              <div className="success-icon">✓</div>
              <h1>{t('payment.success.title', 'Betalning genomförd!')}</h1>
              <p className="success-message">
                {t('payment.success.message', 'Tack för din uppgradering! Din premium-plan är nu aktiv.')}
              </p>
              
              <div className="success-details">
                <div className="detail-item">
                  <span className="detail-icon">📧</span>
                  <div className="detail-text">
                    <strong>{t('payment.success.emailTitle', 'Kvitto skickat')}</strong>
                    <p>{t('payment.success.emailText', 'Ett kvitto har skickats till din email')}</p>
                  </div>
                </div>
                
                <div className="detail-item">
                  <span className="detail-icon">🚀</span>
                  <div className="detail-text">
                    <strong>{t('payment.success.featuresTitle', 'Nya funktioner')}</strong>
                    <p>{t('payment.success.featuresText', 'Du har nu tillgång till alla premium-funktioner')}</p>
                  </div>
                </div>
                
                <div className="detail-item">
                  <span className="detail-icon">💳</span>
                  <div className="detail-text">
                    <strong>{t('payment.success.billingTitle', 'Fakturering')}</strong>
                    <p>{t('payment.success.billingText', 'Du kommer faktureras månadsvis')}</p>
                  </div>
                </div>
              </div>

              <div className="success-actions">
                <button onClick={handleContinue} className="btn-primary">
                  {t('payment.success.goToDashboard', 'Gå till Dashboard')}
                </button>
                <a href="/priser" className="btn-secondary">
                  {t('payment.success.viewPlans', 'Se alla planer')}
                </a>
              </div>

              {sessionId && (
                <p className="session-id">
                  {t('payment.success.sessionId', 'Session ID')}: {sessionId}
                </p>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccess;
